import moment from "moment";

const formatValidityPeriodDisplay = (validity, format = "DD MMM YYYY, h:mma") => {
  if (!validity || !validity?.fromDate || !validity?.toDate) return null;

  // For validity period display, we preserve the exact dates without timezone conversion
  // This ensures that the dates shown match exactly what was stored
  const fromDate = validity.startTime
    ? moment(`${validity.fromDate} ${validity.startTime}`, "YYYY-MM-DD HH:mm")
    : moment(validity.fromDate, "YYYY-MM-DD");

  const toDate = validity.endTime
    ? moment(`${validity.toDate} ${validity.endTime}`, "YYYY-MM-DD HH:mm")
    : moment(validity.toDate, "YYYY-MM-DD");

  return [
    validity.startTime ? fromDate.format(format) : fromDate.format("DD MMM YYYY"),
    validity.endTime ? toDate.format(format) : toDate.format("DD MMM YYYY"),
  ].join(" - ");
};

export default formatValidityPeriodDisplay;
